// extracted by mini-css-extract-plugin
export default {"container":"NumberedItem_container__6hB0X","number":"NumberedItem_number__gTfy7","title":"NumberedItem_title__KLzmD"};